const trimString = ({ str, length = 200 }) => {
  return str.length > length ? `${str.substring(0, length)}...` : str;
};

const mapCmsColour = (value) => {
  switch (value) {
    case "Pink":
      return "secondary";
    case "Teal":
      return "primary";
    case "Black":
      return "black";
    case "White":
      return "white";
    default:
      return "secondary";
  }
};

const getModelSlug = (name) => {
  switch (name) {
    case "Post":
      return "/news";
    case "Game":
      return "/games";
    case "Career":
      return "/careers";
    default:
      return "";
  }
};

const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const processBlogPost = (str) => {
  const re = /&lt;youtube&gt;(.*?)&lt;\/youtube&gt;/g;
  const videos = str.match(re);

  if (videos?.length > 0) {
    for (let i = 0; i < videos.length; i++) {
      const videoId = videos[i]
        .replace("&lt;youtube&gt;", "")
        .replace("&lt;/youtube&gt;", "")
        .replace("</span><span>", "");

      str = str.replace(
        videos[i],
        `<div data-youtube-id="${videoId}" class=""></div>`
      );
    }

    return str;
  } else {
    return str;
  }
};

export {
  trimString,
  mapCmsColour,
  getModelSlug,
  validateEmail,
  processBlogPost,
};
